/**
 * Icon wrapper.
 * Usa nombres de heroicons (outline). El proyecto debe proveer el sprite SVG
 * o integrar una lib de íconos. Por ahora renderiza un slot con aria-hidden.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'pvp-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      aria-hidden="true"
      [class]="iconClass()"
      [attr.data-icon]="name()"
    >
      <!-- El sprite SVG se resuelve a nivel de layout vía un <use> dinámico -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        [class]="svgClass()"
        aria-hidden="true"
      >
        <use [attr.href]="'#icon-' + name()" />
      </svg>
    </span>
  `,
})
export class IconComponent {
  readonly name  = input.required<string>();
  readonly size  = input<IconSize>('md');
  readonly color = input<string>('');

  protected iconClass(): string {
    return 'inline-flex shrink-0 ' + (this.color() || '');
  }

  protected svgClass(): string {
    const sizes: Record<IconSize, string> = {
      xs: 'h-3 w-3',
      sm: 'h-4 w-4',
      md: 'h-5 w-5',
      lg: 'h-6 w-6',
      xl: 'h-8 w-8',
    };
    return sizes[this.size()];
  }
}
